import {TextInput} from '@dropbox/dig-components/text_fields';
import {UIIcon} from '@dropbox/dig-icons';
import {SearchLine} from '@dropbox/dig-icons/assets';
import {t} from 'i18next';

import styles from './Apps.module.css';

export const AppsCatalogSearch = ({
  onQueryChange,
  query,
}: {
  onQueryChange: (query: string) => void;
  query: string;
}) => (
  <TextInput.Container size="medium" className={styles.appCatalogSearch}>
    <TextInput.Accessory>
      <UIIcon src={SearchLine} />
    </TextInput.Accessory>
    <TextInput.Input
      aria-label={t('apps_search_label')}
      maxLength={100}
      onChange={(event) => onQueryChange(event.currentTarget.value)}
      placeholder={t('apps_search_placeholder')}
      value={query}
    />
  </TextInput.Container>
);
